// Meta (Facebook) Pixel loader — mirrors Meta's official snippet exactly,
// just wrapped so it can be called once from the app's entry point.
const META_PIXEL_ID = '2314996429237093';

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      loaded?: boolean;
      version?: string;
      push?: unknown;
    };
    _fbq?: unknown;
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.fbq) return; // already loaded — avoid double-injecting the script

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    if (fbq!.callMethod) {
      fbq!.callMethod(...args);
    } else {
      fbq!.queue!.push(args);
    }
  };
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}
